"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDefaultProfile = void 0;
const Catalyst_1 = __importDefault(require("../api/Catalyst"));
const rollbar_1 = __importDefault(require("../development/rollbar"));
const segment_1 = __importDefault(require("../development/segment"));
const BatchLoader_1 = __importDefault(require("./BatchLoader"));
const DEFAULT_AVATAR = 'https://decentraland.org/images/male.png';
const createDefaultProfile = (address) => ({
    userId: address,
    ethAddress: address,
    hasClaimedName: false,
    avatar: {
        snapshots: {
            face: DEFAULT_AVATAR,
            face128: DEFAULT_AVATAR,
            face256: DEFAULT_AVATAR,
            body: '',
        },
        bodyShape: 'dcl://base-avatars/BaseMale',
        eyes: {
            color: {
                r: 0.125,
                g: 0.703125,
                b: 0.96484375,
            },
        },
        hair: {
            color: {
                r: 0.234375,
                g: 0.12890625,
                b: 0.04296875,
            },
        },
        skin: {
            color: {
                r: 0.94921875,
                g: 0.76171875,
                b: 0.6484375,
            },
        },
        wearables: [
            'dcl://base-avatars/green_hoodie',
            'dcl://base-avatars/brown_pants',
            'dcl://base-avatars/sneakers',
            'dcl://base-avatars/casual_hair_01',
            'dcl://base-avatars/beard',
        ],
        version: 0,
    },
    name: '',
    email: '',
    description: '',
    blocked: [],
    inventory: [],
    version: 0,
    tutorialStep: 0,
    isDefaultProfile: true,
});
exports.createDefaultProfile = createDefaultProfile;
exports.default = new BatchLoader_1.default((addresses) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const profiles = yield Catalyst_1.default.getInstance().getProfiles(addresses.map((address) => address.toLowerCase()));
        return profiles.map((profile, i) => profile || (0, exports.createDefaultProfile)(addresses[i]));
    }
    catch (err) {
        console.error(err);
        (0, rollbar_1.default)((rollbar) => rollbar.error(err));
        (0, segment_1.default)((analytics) => analytics.track('error', Object.assign(Object.assign({}, err), { message: err.message, stack: err.stack })));
        return addresses.map((address) => (0, exports.createDefaultProfile)(address));
    }
}), { maxBatchSize: 100 });
